import { render, staticRenderFns } from "./BranchsManagement.vue?vue&type=template&id=2a66e52f&"
import script from "./BranchsManagement.vue?vue&type=script&lang=js&"
export * from "./BranchsManagement.vue?vue&type=script&lang=js&"
import style0 from "./BranchsManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports